/**
 * Opens a receipt or invoice in a new tab.
 *
 * The document needs the signed-in request (a plain link carries no token), so it
 * is fetched first — but a window opened *after* an await is treated as a pop-up
 * and blocked. So the tab is opened straight from the click, and pointed at the
 * document once it has arrived; if the fetch fails the tab is closed again and
 * the error goes to the caller. A blocked pop-up is reported the same way.
 */
export const openDocument = async (loadHtml) => {
  const tab = window.open("", "_blank");

  if (!tab) throw new Error("popup-blocked");

  try {
    const html = await loadHtml();
    const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));

    tab.opener = null;
    tab.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    tab.close();
    throw error;
  }
};
